<template>
    <div class="chapter_list" v-show="chapterList.list.length">
        <el-table :data="chapterList.list" border :header-cell-style="{'padding': 0}" :cell-style="{'padding': '6px 0'}" ref="sortTable" row-key="id">
				<!-- 	<el-table-column type="index" label="排序">
					</el-table-column> -->
            <div slot="empty">
                <img :src="require(`@/assets/image/${noDataName}.png`)" style="width: 100%;padding: 115px 0;"/>
            </div>
            <el-table-column label="排序" prop="sort" width="80">
            </el-table-column>
            <el-table-column label="标题" prop="title">
            </el-table-column>
            <el-table-column label="状态" width="100"> 
                <template slot-scope="scope">
                    <span v-statusColor="{status: scope.row.status, list: selectList}" style="width: 50px;height:20px;font-size: 12px;line-height:20px;text-align:center;border-radius: 30px;display:inline-block"></span>
                </template>
            </el-table-column>
            <el-table-column label="" width="80">
                <template slot-scope="scope">
                    <span @click="editStatus(scope.row)" style="color: #1989FA;font-size: 14px;cursor: pointer;">操作</span>
                </template>
            </el-table-column>
        </el-table>
        <Pagination @change="changeSize" :total="chapterList.total" ref="pagination" v-model="searchObj.page" v-if="Math.ceil(chapterList.total / searchObj.page_size) > 1" :pageSize="5" class="chapter_pag"></Pagination>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import Pagination from '@/components/pagination/pagination.vue'
import Sortable from 'sortablejs'
import { common } from '@/pages/dy/mixin/common.js'
export default {
    name: 'ChapterList',
    mixins: [common],
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            searchObj: {
                status: '',
                page: 1,
                page_size: 5
            },
            noDataName: 'empty'
        }
    },
    components: {
        Pagination
    },
    computed: {
        ...mapState('chapter',['chapterList']),
        ...mapState(['breadCrumbList'])
    },
    created() {
        if(this.$route.params.id) {
            this.searchObj.id = this.$route.params.id
            this.getShowlists()
        }
    },
    watch: {
        chapterList: {
            deep: true,
            immediate: true,
            handler(news) {
                if(news.total > 0) {
                    this.$emit('input', true)
                } else {
                    this.$emit('input', false)
                }
            }
        }
    },
    methods: {
        ...mapActions('chapter', ['getShowlist']),
        getShowlists(flag) {
            if(flag) {
                this.searchObj.page = 1
            }
            this.getShowlist(this.searchObj)
            // this.rowDrop() //拖拽行，暂时不用
        },
        changeSize(size) {
            this.searchObj.page = size
            this.getShowlists()
        },
        editStatus(row) {
            this.$emit('goChapter', row)
            // let breadCrumbList = this.breadCrumbList.slice(0,3)
            // breadCrumbList[3] = {
            //     path: `/chapter/${this.$route.params.id}/column`,
            //     title: '章节列表'

            // }
            // localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
            // this.$router.push(`/chapter/${this.$route.params.id}/column`)
            // console.log(row, 'ooooop[[[')
        },
        rowDrop() {
            const tbody = this.$refs.sortTable.$el.querySelector('.el-table__body-wrapper tbody')
            console.log(tbody, '...tbody')
            const _this = this
            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                const currRow = _this.chapterList.list.splice(oldIndex, 1)[0]
                _this.chapterList.list.splice(newIndex, 0, currRow)
                console.log(_this.chapterList.list)
                }
            })
        },
    }
}
</script>
<style lang="less" scoped>
    .chapter_list {
        padding-top: 12px;
        .chapter_pag {
            padding: 6px 0;
            line-height: normal;
        }
    }
</style>